/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Studentform_Phone_LabelInputs */

const en_studentform_phone_label = /** @type {(inputs: Studentform_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp phone`)
};

const he_studentform_phone_label = /** @type {(inputs: Studentform_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טלפון וואטסאפ`)
};

/**
* | output |
* | --- |
* | "WhatsApp phone" |
*
* @param {Studentform_Phone_LabelInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const studentform_phone_label = /** @type {((inputs?: Studentform_Phone_LabelInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Studentform_Phone_LabelInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_studentform_phone_label(inputs)
	return he_studentform_phone_label(inputs)
});